import { SxProps, Theme } from '@mui/material';

export const StepTabsStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  teste: {
    display: 'flex'
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    border: `2px solid ${theme.palette.primary.light}`,
    marginTop: '2rem',
    paddingBottom: '1.5rem',
    borderRadius: '16px',
    overflow: 'hidden'
  },
  buttonContainer: { display: 'flex', justifyContent: 'center' },
  button: {
    width: '100%',
    borderRadius: '1rem 1rem 0 0',
    backgroundColor: theme.customColors.gray[700],
    borderBottom: `2px solid ${theme.palette.primary.light}`,
    '& + button': {
      borderRadius: '0 1rem 0 0',
      borderLeft: `1px solid ${theme.palette.primary.light}`,
      borderBottom: `2px solid ${theme.palette.primary.light}`
    },
    '&:has(+ button)': {
      borderRadius: '1rem 0 0 0',
      borderBottom: `2px solid ${theme.palette.primary.light}`,
      borderRight: `1px solid ${theme.palette.primary.light}`
    }
  },
  buttonSelected: {
    backgroundColor: theme.palette.primary.light,
    width: '100%',
    borderRadius: '1rem 1rem 0 0',
    borderBottom: `2px solid ${theme.palette.primary.light}`,
    '& + button': {
      borderRadius: '0 1rem 0 0',
      borderLeft: `1px solid ${theme.palette.primary.light}`,
      borderBottom: `2px solid ${theme.palette.primary.light}`
    },
    '&:has(+ button)': {
      borderRadius: '1rem 0 0 0',
      borderBottom: `2px solid ${theme.palette.primary.light}`,
      borderRight: `1px solid ${theme.palette.primary.light}`
    }
  }
});
